module.exports = __webpack_public_path__ + "img/search.dbdd1108.svg";